module.exports = __webpack_public_path__ + "img/downarrow.80df43e5.svg";